import React from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const bob = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
`;

const AiGuideRobot = ({ size = 56 }) => (
	<Box
		as='span'
		display='inline-flex'
		flexShrink={0}
		animation={`${bob} 2.4s ease-in-out infinite`}
		aria-hidden>
		<svg
			width={size}
			height={size}
			viewBox='0 0 64 64'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<rect x='14' y='22' width='36' height='30' rx='10' fill='#1ABC9C' />
			<rect x='18' y='26' width='28' height='20' rx='6' fill='#E8FFF9' />
			<circle cx='26' cy='36' r='4' fill='#148F77' />
			<circle cx='38' cy='36' r='4' fill='#148F77' />
			<circle cx='27' cy='35' r='1.5' fill='white' />
			<circle cx='39' cy='35' r='1.5' fill='white' />
			<rect x='28' y='42' width='8' height='2' rx='1' fill='#148F77' />
			<rect x='28' y='8' width='8' height='10' rx='3' fill='#1ABC9C' />
			<circle cx='32' cy='6' r='4' fill='#F6AD55' />
			<rect x='8' y='30' width='8' height='16' rx='4' fill='#16A085' />
			<rect x='48' y='30' width='8' height='16' rx='4' fill='#16A085' />
			<rect x='20' y='52' width='10' height='8' rx='3' fill='#148F77' />
			<rect x='34' y='52' width='10' height='8' rx='3' fill='#148F77' />
		</svg>
	</Box>
);

export default AiGuideRobot;
